module.exports = __webpack_public_path__ + "img/image2.6f07908c.png";